export default __webpack_public_path__ + "static/media/create.5bf462d3.svg";